<div class="flex flex-col gap-1">
  @if (showMapa()) {
    @if (isMapaCarregado()) {
      <div class="mapa-wrapper" [class.mapa-flex]="mapaAlturaDinamica()">
        <google-map
          (mapInitialized)="onMapInitialized($event)"
          [center]="center"
          [mapId]="mapId"
          [options]="mapOptions"
          [zoom]="zoom"
          width="100%"
          height="100%"
        >
          @if (posicaoPinSelecionado()) {
            <map-advanced-marker
              [position]="posicaoPinSelecionado()!"
              [content]="pinSelecionadoContent()"
            />
          }
        </google-map>
      </div>
    } @else {
      <div class="mapa-wrapper flex items-center justify-center bg-gray-100 rounded"
           [class.mapa-flex]="mapaAlturaDinamica()">
        <span class="text-gray-400 text-sm">Carregando mapa...</span>
      </div>
    }
  }
  <div [ngClass]="{'gap-0': mapaAlturaDinamica(), 'gap-2': !mapaAlturaDinamica()}" class="grid grid-cols-2 w-full">
    @if (showTipoObra() && tipoObraId()) {
      <app-input-select-tipo-obra
        [initialValue]="tipoObraId()"
        [readonly]="true"
        class="!py-0"
      />
    }
    <div class="flex flex-col">
      <span class="font-medium">Concessionária</span>
      <span>{{ dadosLocalizacao()?.concessionaria }}</span>
    </div>
    <div class="flex flex-col">
      <span class="font-medium">Longitude</span>
      <span>{{ dadosLocalizacao()?.longitude }}</span>
    </div>
    <div class="flex flex-col">
      <span class="font-medium">Latitude</span>
      <span>{{ dadosLocalizacao()?.latitude }}</span>
    </div>
    <div class="flex flex-col">
      <span class="font-medium">Município</span>
      <span>{{ dadosLocalizacao()?.municipio }}</span>
    </div>
    <div class="flex flex-col">
      <span class="font-medium">Código da Rodovia</span>
      <span>{{ dadosLocalizacao()?.codRodovia }}</span>
    </div>
    @if (showData()) {
      <div class="flex flex-col">
        <span class="font-medium">Data</span>
        <span>{{ dadosLocalizacao()?.data | datePtbr }}</span>
      </div>
    }
  </div>
</div>
